// PureDrop — JS compartido de las secciones propias (prefijo pd-)

document.addEventListener('DOMContentLoaded', function () {
  initRevealPD();
  initContadoresPD();
});

function initRevealPD() {
  var els = document.querySelectorAll('.pd-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('pd-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-pd-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('pd-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initContadoresPD() {
  var els = document.querySelectorAll('[data-pd-contador]');
  if (!els.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = Number(el.getAttribute('data-pd-contador')) || 0;
        var duracion = 1400;
        var inicio = null;

        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * fin);
          el.textContent = valor.toLocaleString('es-ES');
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString('es-ES');
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );

  els.forEach(function (el) { observer.observe(el); });
}
